import { defineMessages } from 'react-intl';

const messages = defineMessages({
  templateModalTitle: {
    id: 'templateModalTitle',
    defaultMessage: 'Select a template',
  },
  noAvailableTemplates: {
    id: 'noAvailableTemplates',
    defaultMessage: 'No available templates',
  },
  selectTemplateButton: {
    id: 'selectTemplateButton',
    defaultMessage: 'Select template',
  },
  modalWithoutTemplateButton: {
    id: 'modalWithoutTemplateButton',
    defaultMessage: 'Continue without template',
  },
  modalCancelButton: {
    id: 'modalCancelButton',
    defaultMessage: 'Cancel',
  },
  createTemplateButton: {
    id: 'createTemplateButton',
    defaultMessage: 'Create template',
  },
  templateFormTitle: {
    id: 'templateFormTitle',
    defaultMessage: 'Title',
  },
  templateFormDescription: {
    id: 'templateFormDescription',
    defaultMessage: 'Description',
  },
  createTemplateModalTitle: {
    id: 'createTemplateModalTitle',
    defaultMessage: 'Create a new template',
  },
  templateFormRequiredField: {
    id: 'templateFormRequiredField',
    defaultMessage: 'This field is required',
  },
  openImageInNewTab: {
    id: 'openImageInNewTab',
    defaultMessage: 'Open image in new tab',
  },
  blockSettings: {
    id: 'Block settings',
    defaultMessage: 'Block settings',
  },
  default: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  placeholder: {
    id: 'Helper text',
    defaultMessage: 'Helper text',
  },
  placeholderDescription: {
    id: 'A short hint that describes the expected value within this block',
    defaultMessage:
      'A short hint that describes the expected value within this block',
  },
  required: {
    id: 'Required',
    defaultMessage: 'Required',
  },
  requiredDescription: {
    id: "Don't allow deletion of this block",
    defaultMessage: "Don't allow deletion of this block",
  },
  fixed: {
    id: 'Fixed position',
    defaultMessage: 'Fixed position',
  },
  fixedDescription: {
    id: 'Disable drag & drop on this block',
    defaultMessage: 'Disable drag & drop on this block',
  },
  disableNewBlocks: {
    id: 'Disable new blocks',
    defaultMessage: 'Disable new blocks',
  },
  disableNewBlocksDescription: {
    id: 'Disable creation of new blocks after this block',
    defaultMessage: 'Disable creation of new blocks after this block',
  },
  readOnly: {
    id: 'Read-only',
    defaultMessage: 'Read-only',
  },
  readOnlyDescription: {
    id: 'Disable editing on this block',
    defaultMessage: 'Disable editing on this block',
  },
});

export default messages;
